var React = require('react');

function Gem (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 12H72L88 36L48 88L8 36L24 12Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M52 12L64 36L48 88L32 36L44 12M8 36H88","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Gem.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Gem;

Gem.default = Gem;
